// Dependencies
import React from 'react';
import { ThemeContext } from '../../components/theme/Theme.jsx';
import radium from 'radium';

function DisplaySubtotal(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			textAlign: 'center',
			margin: '2em 0 1em',
		},
		subtotal: {
			fontSize: context.themeManager.value('event-subtotal', 'fontSize', 'font-size-400'),
			fontWeight: '600',
		},
		info: {
			fontSize: context.themeManager.value('event-subtotal-info',
				'fontSize', 'font-size-80'),
			lineHeight: context.themeManager.value('event-subtotal-info',
				'lineHeight', 'line-height-200'),
		},
	};

	return (
		<div className="subtotal__container" style={style.container}>
			<span style={style.subtotal}>Summe {parseFloat(props.subtotal).toFixed(2)} €</span>
			<br />
			<span style={style.info}>{context.themeManager.getCheckoutPriceLegalNoteOrDefault()}</span>
		</div>
	);
}

const RadiumDisplaySubtotal = radium(DisplaySubtotal);

export default RadiumDisplaySubtotal;

